import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="app-header">
      <div className="header-placeholder" />
    </header>
  );
};

export default React.memo(Header);
